module.exports = __webpack_public_path__ + "static/media/font_regular.8961eb2e.woff";